export default __webpack_public_path__ + "static/media/172.95c2bfad.png";